import React from 'react';
import './style.scss';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Marker } from '@react-google-maps/api';
import Form from '../../../../components/molecules/forms';
import Gmaps from '../../../../components/organisms/maps';
import googleMapStyle from './googleMapStyle.json';
import Forms from '../../../../components/organisms/forms';
import useRoutesClient from './hooks';
import RenderVendingMachines from './RenderVendingMachines';

interface Props {
  formik: any;
  client: number | string;
  index: number;
  edit?: boolean;
  clients?: number [];
  id: string | undefined;
  isNew?: boolean;
}

function RoutesClientForms(props: Props): React.ReactElement {
  const {
    formik, client, index, edit, clients, id, isNew,
  } = props;
  const {
    clientList, handleShow, show, handleChangeEnd, handleChangeStart,
    selectedClient, handleChangeClient,
  } = useRoutesClient(client, formik, clients, isNew);

  const renderTitle = () => {
    console.log(selectedClient);
    if (selectedClient) {
      return selectedClient.label;
    }
    return edit ? 'Edit Client Details' : 'Add Client Details';
  };

  const renderHideShowArrow = () => {
    if (edit) return null;
    if (show) {
      return (
        <KeyboardArrowUpIcon
          sx={{ fontSize: '30px' }}
          role="button"
          onClick={handleShow}
        />
      );
    }
    return (
      <KeyboardArrowDownIcon
        sx={{ fontSize: '30px' }}
        role="button"
        onClick={handleShow}
      />
    );
  };

  return (
    <div className={`px-4 px-xl-5 pt-4 ${!edit ? 'border-bottom' : ''} ${show ? 'pb-4' : 'pb-3'}`}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className={`${show ? 'fw-bold' : ''} fz-16`} style={{ marginLeft: '20px' }}>
          {renderTitle()}
        </div>
        {renderHideShowArrow()}
      </div>
      <div className={show ? '' : 'd-none'}>
        <div className="row">
          <div className="col-lg-7">
            <div className="mb-4">
              <Form.ReactSelect.Default
                id="client"
                label="Choose Client"
                placeholder="Choose Client"
                options={clientList}
                onChange={(e) => handleChangeClient(e, index)}
                value={selectedClient}
                disabled={selectedClient?.disabled}
              />
            </div>
            <div className="row">
              <div className={selectedClient?.vendingMachines ? 'mb-4' : ''}>
                <RenderVendingMachines vendingMachines={selectedClient?.vendingMachines} />
              </div>
              <div className="mb-lg-0 mb-4">
                <Forms.TimeRangePicker
                  id="timeRangePicker"
                  label="Enter Time Range"
                  handleChangeEnd={handleChangeEnd}
                  handleChangeStart={handleChangeStart}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-5 mt-lg-0 mt-4">
            <div className="w-100 mb-4 ratio ratio-16x9">
              <Gmaps
                position={selectedClient?.position}
                options={{
                  disableDefaultUI: true,
                  scrollwheel: false,
                  draggable: false,
                  clickableIcons: false,
                  styles: googleMapStyle,
                }}
              >
                {selectedClient?.position && <Marker position={selectedClient?.position} />}
              </Gmaps>
            </div>
            <Form.Default
              id="address"
              placeholder="Choose client location will be added"
              readOnly
              value={selectedClient?.address ?? ''}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

RoutesClientForms.defaultProps = {
  edit: false,
  clients: [],
  isNew: false,
};

export default RoutesClientForms;
